const data = {
  ProgramDynamicCap: {
    ProgramCapList: [
      {
        ProgramCap: {
          id: 1,
          programType: "normal",
          maxPageNum: "16",
          // maxPageNum: "32",
          maxTotalMaterialNum: "512",
          maxWinNum: "64",
          // maxWinNum: "128",
          maxMaterialNum: "64",
          // maxMaterialNum: "256",
          isSupportTouch: "false",
          WinCapList: [
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1920",
                  resHeight: "1080",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "6",
                      // maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1080",
                  resHeight: "1920",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "3840",
                  resHeight: "2160",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "2160",
                  resHeight: "3840",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        ProgramCap: {
          id: 2,
          programType: "decode",
          maxPageNum: "16",
          // maxPageNum: "32",
          maxTotalMaterialNum: "512",
          maxWinNum: "64",
          // maxWinNum: "128",
          maxMaterialNum: "64",
          // maxMaterialNum: "256",
          isSupportTouch: "false",
          WinCapList: [
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1920",
                  resHeight: "1080",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "300",
                        defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1080",
                  resHeight: "1920",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1422",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "533",
                        defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "3840",
                  resHeight: "2160",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "300",
                        defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "2160",
                  resHeight: "3840",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1422",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "533",
                        defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        ProgramCap: {
          id: 3,
          programType: "touch",
          maxPageNum: "16",
          // maxPageNum: "32",
          maxTotalMaterialNum: "512",
          maxWinNum: "64",
          // maxWinNum: "128",
          maxMaterialNum: "64",
          // maxMaterialNum: "256",
          isSupportTouch: "true",
          WinCapList: [
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1920",
                  resHeight: "1080",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 360,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 320,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "700",
                        defaultHeight: "662",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "6",
                      // maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1080",
                  resHeight: "1920",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 640,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 180,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1241",
                        defaultHeight: "394",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "3840",
                  resHeight: "2160",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 360,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 320,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "700",
                        defaultHeight: "662",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "2160",
                  resHeight: "3840",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 640,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 180,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1241",
                        defaultHeight: "394",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "64",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
      {
        ProgramCap: {
          id: 3,
          programType: "fold",
          maxPageNum: "16",
          // maxPageNum: "32",
          maxTotalMaterialNum: "512",
          maxWinNum: "64",
          // maxWinNum: "128",
          maxMaterialNum: "8",
          // maxMaterialNum: "256",
          isSupportTouch: "false",
          WinCapList: [
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1920",
                  resHeight: "1080",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 360,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 320,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "700",
                        defaultHeight: "662",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      // maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      // maxWinNum: "128",
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                        // defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 150,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "1080",
                  resHeight: "1920",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 640,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 180,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1241",
                        defaultHeight: "394",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 200,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 214,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "3840",
                  resHeight: "2160",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 360,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 320,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "700",
                        defaultHeight: "662",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "88",
                        defaultHeight: "158",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "324",
                        // defaultWidth: "800",
                        defaultHeight: "288",
                        // defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "640",
                        // defaultWidth: "300",
                        defaultHeight: "409",
                        // defaultHeight: "889",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "200",
                        defaultHeight: "178",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
            {
              WinCap: {
                id: 0,
                BaseRes: {
                  resWidth: "2160",
                  resHeight: "3840",
                },
                WinSizeList: [
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "signalSource",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 640,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 180,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1241",
                        defaultHeight: "394",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "picture",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      width: {
                        "@min": 48,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 24,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "audio",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "158",
                        defaultHeight: "88",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "video",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "document",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "ppt",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "doc",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "excel",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "128",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "pdf",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "web",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "app",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "static",
                        staticMaterialType: "zip",
                        dynamicType: "",
                        otherType: "",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 1920,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1920",
                        defaultHeight: "1920",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "call",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "chart",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "dynamicPic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "600",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "realStream",
                        otherType: "",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1137",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "capturePic",
                        otherType: "",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "360",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "picUrl",
                        otherType: "",
                      },
                      maxWinNum: "32",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "800",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "dynamic",
                        staticMaterialType: "",
                        dynamicType: "character",
                        otherType: "",
                      },
                      maxWinNum: "8",
                      // maxWinNum: "128",
                      width: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 55,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "120",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "clock",
                      },
                      maxWinNum: "1",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "576",
                        // defaultWidth: "1422",
                        defaultHeight: "340",
                        // defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "weather",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "1138",
                        // defaultWidth: "533",
                        defaultHeight: "189",
                        // defaultHeight: "500",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "countdown",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 80,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "localInput",
                      },
                      maxWinNum: "4",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "800",
                        defaultHeight: "1137",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "hyperlinkBtn",
                      },
                      maxWinNum: "16",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 100,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "356",
                        defaultHeight: "100",
                      },
                    },
                  },
                  {
                    WinSize: {
                      id: 0,
                      WinMaterialInfo: {
                        materialType: "other",
                        staticMaterialType: "",
                        dynamicType: "",
                        otherType: "RSS",
                      },
                      maxWinNum: "2",
                      width: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      height: {
                        "@min": 120,
                        "@max": 1920,
                      },
                      DefaultSize: {
                        defaultWidth: "650",
                        defaultHeight: "325",
                      },
                    },
                  },
                ],
              },
            },
          ],
        },
      },
    ],
  },
};
export default data